export const trueFalseSelectOptions = [
  { value: true, label: 'True' },
  { value: false, label: 'False' },
]
